(function (){
    'use strict';

    angular
        .module('highSchoolVisit', [
            'ui.router',
            'ui.bootstrap',
            'ngDialog',
            'ui.select',
            'ngSanitize',
            'vAccordion',
            'ngAnimate',
            'ui.footable'
        ]);
})();